import { render } from "./ChildDedicationCertificate.vue?vue&type=template&id=e09b4fbc"
import script from "./ChildDedicationCertificate.vue?vue&type=script&lang=js"
export * from "./ChildDedicationCertificate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__